var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicalDocSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0026 0H2.75033C1.23765 0 0.0137516 1.28033 0.0137516 2.84517L0 22.7613C0 24.3262 1.23765 25.6065 2.75033 25.6065H22.0026C23.5153 25.6065 24.753 24.3262 24.753 22.7613V2.84517C24.753 1.28033 23.5153 0 22.0026 0ZM20.6275 15.6484H15.1268V21.3388H9.62615V15.6484H4.12549V9.95809H9.62615V4.26775H15.1268V9.95809H20.6275V15.6484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalDocSelected);
export default __webpack_public_path__ + "static/media/clinicalDoc-selected.104d524fee06c54986fb1623cb02ed5e.svg";
export { ForwardRef as ReactComponent };